import * as Sentry from '@sentry/browser';

import * as APIClient from './APIClient';

export const post = segmentName =>
  APIClient.post('/v1/tag_segment', { segment_name: segmentName }).catch(error =>
    Sentry.withScope(scope => {
      scope.setLevel('error');
      Sentry.captureMessage(`[Tag segment error: ${segmentName}] error: ${error.toString()}`);
    })
  );
